import axiosInstance from '@/api/apiClient'
import { getErrorMessage } from '@/lib/utils'

export interface ResearchAdjudicationDraftApi {
  id: number
  student_decision_id: number
  suggested_adjudication: string | null
  status: string
  error_message: string | null
  created_at: string | null
}

export async function postResearchAdjudicationDrafts(
  roomId: string,
  body: { round_number?: number; decision_ids?: number[] }
): Promise<{ drafts: ResearchAdjudicationDraftApi[] }> {
  try {
    const response = await axiosInstance.post(
      `/oge/rooms/${roomId}/research-adjudication-drafts/`,
      body
    )
    return response.data
  } catch (error) {
    throw new Error(getErrorMessage(error))
  }
}

export async function getResearchAdjudicationDrafts(
  roomId: string,
  params?: { round?: string }
): Promise<{ drafts: ResearchAdjudicationDraftApi[] }> {
  try {
    const response = await axiosInstance.get(
      `/oge/rooms/${roomId}/research-adjudication-drafts/`,
      { params }
    )
    return response.data
  } catch (error) {
    throw new Error(getErrorMessage(error))
  }
}

export async function getResearchDecisionOptionsForPhase(
  roomId: string,
  phaseId: number
): Promise<{
  phase_id: number
  student_id: number
  options: string[]
  status: string
  error_message?: string | null
}> {
  try {
    const response = await axiosInstance.get(
      `/oge/rooms/${roomId}/phases/${phaseId}/research-decision-options/`
    )
    return response.data
  } catch (error) {
    throw new Error(getErrorMessage(error))
  }
}
